import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Stack} from 'views/components';
import {Tab, TabContext, TabList, TabPanel} from 'views/components';

import {translate} from 'views/module';

import JobHeader from './header/JobHeader';
import JobInformation from './job_information/JobInformation';
import InternalApplications from './job_applications/InternalApplications';

const JobFeed = (props) => {
  const {
    feedTab,
    setFeedTab,
    applications,
  } = props;

  const handleChange = (event, newValue) => {
    setFeedTab(newValue);
  };

  const tallyByStatus = React.useCallback((list = []) => {
    return list.reduce((acc, application) => {
      switch (application?.status) {
        case 'PENDING':
          acc.P += 1;
          break;
        case 'ACCEPTED':
          acc.A += 1;
          break;
        case 'REJECTED':
          acc.R += 1;
          break;
        default:
          break;
      }
      return acc;
    }, {P: 0, A: 0, R: 0});
  }, []);

  const internalCounts = React.useMemo(() => tallyByStatus(applications || []), [applications, tallyByStatus]);

  return (
    <Paper >
      <Stack>
        <JobHeader
          {...props}
        />
        <TabContext
          value={feedTab}
        >
          <TabList
            onChange={handleChange}
            sx={{borderBottom: 1, borderColor: 'divider'}}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              label={translate('career.jobDetail.Tabs.Information')}
              value="INFORMATION"
            />
            <Tab
              label={translate('career.jobDetail.Tabs.InternalApplications', {
                p: internalCounts.P,
                a: internalCounts.A,
                r: internalCounts.R,
              })}
              value="INTERNAL_APPLICATIONS"
            />
          </TabList>
          <TabPanel
            value={'INFORMATION'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <JobInformation
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'INTERNAL_APPLICATIONS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <InternalApplications
              {...props}
            />
          </TabPanel>
        </TabContext>
      </Stack>
    </Paper>
  );
};

JobFeed.propTypes = {
  feedTab: PropTypes.string.isRequired,
  setFeedTab: PropTypes.func.isRequired,
  applications: PropTypes.array,
};

export default React.memo(JobFeed);
